// extracted by mini-css-extract-plugin
module.exports = {"brandInfo":"BrandInfo_brandInfo__37226","textLink":"BrandInfo_textLink__ddcf2"};